<div class="blackout-time-dropdown" [attr.data-testid]="testIdPrefix">
  <div class="blackout-dropdown-selects">
    <div class="select is-small">
      <select
        [disabled]="disabled"
        [(ngModel)]="hour"
        (ngModelChange)="onChange()"
        [attr.data-testid]="testIdPrefix + '-hour'"
        [attr.aria-label]="(ariaLabel ? ariaLabel + ' ' : '') + 'hour'"
      >
        <option *ngFor="let h of BLACKOUT_HOUR_OPTIONS" [ngValue]="h">{{ h }}</option>
      </select>
    </div>
    <span class="blackout-time-colon">:</span>
    <div class="select is-small">
      <select
        [disabled]="disabled"
        [(ngModel)]="minute"
        (ngModelChange)="onChange()"
        [attr.data-testid]="testIdPrefix + '-minute'"
        [attr.aria-label]="(ariaLabel ? ariaLabel + ' ' : '') + 'minute'"
      >
        <option *ngFor="let m of BLACKOUT_MINUTE_OPTIONS" [ngValue]="m">{{ m }}</option>
      </select>
    </div>
  </div>
</div>
